module.exports = __webpack_public_path__ + "img/96.6d6a5fc4.jpg";